import httpClient from './httpClient';

function mdDownloadBlob(mdBlob: Blob, mdFileName: string): void {
  const mdUrl = URL.createObjectURL(mdBlob);
  const mdLink = document.createElement('a');
  mdLink.href = mdUrl;
  mdLink.download = mdFileName;
  mdLink.click();
  URL.revokeObjectURL(mdUrl);
}

export async function downloadInvoicePdf(mdInvoiceId: string): Promise<void> {
  const mdResponse = await httpClient.get(`/export/invoice/${mdInvoiceId}/pdf`, {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], { type: 'application/pdf' });
  mdDownloadBlob(mdBlob, `invoice-${mdInvoiceId}.pdf`);
}

export async function downloadRecallPdf(mdRecallId: string): Promise<void> {
  const mdResponse = await httpClient.get(`/export/recall/${mdRecallId}/pdf`, {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], { type: 'application/pdf' });
  mdDownloadBlob(mdBlob, `recall-${mdRecallId}.pdf`);
}

export async function downloadServiceActPdf(mdRequestId: string): Promise<void> {
  const mdResponse = await httpClient.get(`/export/service-request/${mdRequestId}/pdf`, {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], { type: 'application/pdf' });
  mdDownloadBlob(mdBlob, `service-act-${mdRequestId}.pdf`);
}

export async function downloadStockExcel(): Promise<void> {
  const mdResponse = await httpClient.get('/export/stock/excel', {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  mdDownloadBlob(mdBlob, 'stock-report.xlsx');
}

export async function downloadSalesExcel(mdFrom?: string, mdTo?: string): Promise<void> {
  const mdParams: Record<string, string> = {};
  if (mdFrom) mdParams.from = mdFrom;
  if (mdTo) mdParams.to = mdTo;
  const mdResponse = await httpClient.get('/export/sales/excel', {
    params: mdParams,
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  mdDownloadBlob(mdBlob, 'sales-report.xlsx');
}

export async function downloadArExcel(): Promise<void> {
  const mdResponse = await httpClient.get('/export/ar/excel', {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  mdDownloadBlob(mdBlob, 'ar-report.xlsx');
}

export async function downloadProductsExcel(): Promise<void> {
  const mdResponse = await httpClient.get('/export/products/excel', {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  mdDownloadBlob(mdBlob, 'products.xlsx');
}

export async function downloadPurchaseOrderPdf(mdOrderId: string): Promise<void> {
  const mdResponse = await httpClient.get(`/export/purchase-order/${mdOrderId}/pdf`, {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], { type: 'application/pdf' });
  mdDownloadBlob(mdBlob, `purchase-order-${mdOrderId}.pdf`);
}

export async function downloadSalesOrderPdf(mdOrderId: string): Promise<void> {
  const mdResponse = await httpClient.get(`/export/sales-order/${mdOrderId}/pdf`, {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], { type: 'application/pdf' });
  mdDownloadBlob(mdBlob, `sales-order-${mdOrderId}.pdf`);
}

export async function downloadInventoryCountPdf(mdCountId: string): Promise<void> {
  const mdResponse = await httpClient.get(`/export/inventory-count/${mdCountId}/pdf`, {
    responseType: 'blob',
  });
  const mdBlob = new Blob([mdResponse.data], { type: 'application/pdf' });
  mdDownloadBlob(mdBlob, `inventory-count-${mdCountId}.pdf`);
}

export async function emailInvoice(mdInvoiceId: string): Promise<void> {
  await httpClient.post(`/export/invoice/${mdInvoiceId}/email`);
}
